import { Clock3, Droplets, Milk, Moon, Pencil, Trash2 } from 'lucide-react';

import { eventSummary, formatDateTime } from '../lib/format.js';

const ICONS = { feed: Milk, poop: Clock3, pee: Droplets, sleep: Moon };

export default function Timeline({ events, emptyText = '这段时间还没有记录', emptyAction, onEdit, onDelete, limit }) {
  const visible = limit ? events.slice(0, limit) : events;
  if (!visible.length) {
    return <div className="empty-state"><strong>{emptyText}</strong><span>记录后会显示在这里，方便全家照护者核对。</span>{emptyAction ? <button type="button" className="button button--secondary" onClick={emptyAction.onClick}>{emptyAction.label}</button> : null}</div>;
  }

  return (
    <div className="timeline">
      {visible.map((event) => {
        const Icon = ICONS[event.kind] ?? Clock3;
        return (
          <article className={`timeline-row timeline-row--${event.kind}`} key={event.id}>
            <span className="timeline-row__icon" aria-hidden="true"><Icon size={18} /></span>
            <div className="timeline-row__body">
              <strong>{eventSummary(event)}</strong>
              <span>{formatDateTime(event.startedAt)}{event.note ? ` · ${event.note}` : ''}</span>
            </div>
            <div className="timeline-row__actions">
              {onEdit ? <button type="button" className="icon-button icon-button--small" onClick={() => onEdit(event)} aria-label="编辑记录"><Pencil size={16} /></button> : null}
              {onDelete ? <button type="button" className="icon-button icon-button--small icon-button--danger" onClick={() => onDelete(event)} aria-label="删除记录"><Trash2 size={16} /></button> : null}
            </div>
          </article>
        );
      })}
    </div>
  );
}
